module.exports = __webpack_public_path__ + "img/back.1b591674.png";